"use strict";

var _defineProperty = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");
var _toConsumableArray = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");
var _slicedToArray = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.verifyCatIsInside = exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var THREE = _interopRequireWildcard(require("three"));
var _reactThreeFiber = require("react-three-fiber");
var _GLTFLoader = require("three/examples/jsm/loaders/GLTFLoader");
var _OrbitControls = require("three/examples/jsm/controls/OrbitControls");
var _reactInfiniteScroller = _interopRequireDefault(require("react-infinite-scroller"));
var _reactIntl = require("react-intl");
var _utils = require("../utils");
var _SSAOPass = require("three/examples/jsm/postprocessing/SSAOPass");
var _EffectComposer = require("three/examples/jsm/postprocessing/EffectComposer");
var _PlanCellHozizontal = _interopRequireDefault(require("./PlanCellHozizontal"));
var _GLTFView = _interopRequireDefault(require("./GLTFView"));
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}
function _interopRequireWildcard(e, t) {
  if ("function" == typeof WeakMap) var r = new WeakMap(),
    n = new WeakMap();
  return (_interopRequireWildcard = function _interopRequireWildcard(e, t) {
    if (!t && e && e.__esModule) return e;
    var o,
      i,
      f = {
        __proto__: null,
        default: e
      };
    if (null === e || "object" != typeof e && "function" != typeof e) return f;
    if (o = t ? n : r) {
      if (o.has(e)) return o.get(e);
      o.set(e, f);
    }
    for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
    return f;
  })(e, t);
}
var PlanCell = function PlanCell(_ref) {
  var cell = _ref.cell,
    page = _ref.page,
    _ref$uriTransformer = _ref.uriTransformer,
    uriTransformer = _ref$uriTransformer === void 0 ? function (u) {
      return u;
    } : _ref$uriTransformer,
    intl = _ref.intl,
    defaultLanguage = _ref.defaultLanguage,
    project = _ref.project,
    logEvent = _ref.logEvent;
  var _ref2 = (0, _react.useState)([]),
    _ref3 = _slicedToArray(_ref2, 2),
    selected = _ref3[0],
    setSelected = _ref3[1];
  var _ref4 = (0, _react.useState)(''),
    _ref5 = _slicedToArray(_ref4, 2),
    search = _ref5[0],
    setSearch = _ref5[1];
  var _ref6 = (0, _react.useState)(null),
    _ref7 = _slicedToArray(_ref6, 2),
    uri = _ref7[0],
    setUri = _ref7[1];
  var _ref8 = (0, _react.useState)(''),
    _ref9 = _slicedToArray(_ref8, 2),
    placeholder = _ref9[0],
    setPlaceholder = _ref9[1];
  var _ref0 = (0, _react.useState)(''),
    _ref1 = _slicedToArray(_ref0, 2),
    viewMore = _ref1[0],
    setViewMore = _ref1[1];
  var _ref10 = (0, _react.useState)(''),
    _ref11 = _slicedToArray(_ref10, 2),
    back = _ref11[0],
    setBack = _ref11[1];
  var _ref12 = (0, _react.useState)([]),
    _ref13 = _slicedToArray(_ref12, 2),
    categories = _ref13[0],
    setCategories = _ref13[1];
  var _ref14 = (0, _react.useState)(''),
    _ref15 = _slicedToArray(_ref14, 2),
    all = _ref15[0],
    setAll = _ref15[1];
  var _ref16 = (0, _react.useState)(''),
    _ref17 = _slicedToArray(_ref16, 2),
    catSelected = _ref17[0],
    setCatSelected = _ref17[1];
  var _ref18 = (0, _react.useState)(''),
    _ref19 = _slicedToArray(_ref18, 2),
    font = _ref19[0],
    setFont = _ref19[1];
  var _ref20 = (0, _react.useState)(cell.expos),
    _ref21 = _slicedToArray(_ref20, 2),
    expos = _ref21[0],
    setExpos = _ref21[1];
  var _ref22 = (0, _react.useState)([]),
    _ref23 = _slicedToArray(_ref22, 2),
    items = _ref23[0],
    setItems = _ref23[1];
  var _ref24 = (0, _react.useState)(true),
    _ref25 = _slicedToArray(_ref24, 2),
    hasMore = _ref25[0],
    setHasMore = _ref25[1];
  var _ref26 = (0, _react.useState)(0),
    _ref27 = _slicedToArray(_ref26, 2),
    indexDatas = _ref27[0],
    setIndexDatas = _ref27[1];
  var _ref28 = (0, _react.useState)('HALL'),
    _ref29 = _slicedToArray(_ref28, 2),
    hallLabel = _ref29[0],
    setHallLabel = _ref29[1];
  var _ref30 = (0, _react.useState)(false),
    _ref31 = _slicedToArray(_ref30, 2),
    showOptions = _ref31[0],
    setShowOptions = _ref31[1];
  var _ref32 = (0, _react.useState)(false),
    _ref33 = _slicedToArray(_ref32, 2),
    planLoaded = _ref33[0],
    setPlanLoaded = _ref33[1];
  var _ref34 = (0, _react.useState)(''),
    _ref35 = _slicedToArray(_ref34, 2),
    closeText = _ref35[0],
    setCloseText = _ref35[1];
  var selectionSourceRef = (0, _react.useRef)(null);
  var loader_uri = 'https://web-treeosk.online/apks/tractor_loader.gif';
  var loader_uri_transformed = uriTransformer(loader_uri);
  (0, _react.useEffect)(function () {
    var exposSorted = expos.sort(function (elem1, elem2) {
      var _i18nData, _i18nData2;
      var elem1Name = (_i18nData = (0, _utils.i18nData)(elem1, 'expo_name', intl, defaultLanguage)) !== null && _i18nData !== void 0 ? _i18nData : "";
      var elem2Name = (_i18nData2 = (0, _utils.i18nData)(elem2, 'expo_name', intl, defaultLanguage)) !== null && _i18nData2 !== void 0 ? _i18nData2 : "";
      return elem1Name.localeCompare(elem2Name);
    });
    setExpos(exposSorted);
  }, [cell.expos, intl.locale]);
  (0, _react.useEffect)(function () {
    if (project) {
      setFont(project.default_button_font);
    }
  }, []);
  (0, _react.useEffect)(function () {
    var transformedUri = uriTransformer(cell.plan_uri);
    if (transformedUri !== uri) {
      setUri(transformedUri);
    }
  }, [cell.plan_uri, uri, uriTransformer]);
  (0, _react.useEffect)(function () {
    switch (intl.locale) {
      case 'fr':
        setPlaceholder('Cherchez un exposant');
        setViewMore('Voir plus');
        setBack('Retour');
        setAll('Catégorie');
        setHallLabel('Hall');
        setCloseText('Fermer');
        break;
      case 'nl':
        setPlaceholder('Zoek een exposant');
        setViewMore('Bekijk meer');
        setBack("Terug");
        setAll('Categorie');
        setHallLabel('Hal');
        setCloseText('Sluiten');
        break;
      case 'en':
        setPlaceholder('Find an exhibitor');
        setViewMore('View more');
        setBack('back');
        setAll('Category');
        setHallLabel('Hall');
        setCloseText('Close');
      default:
        setPlaceholder('Find an exhibitor');
        setViewMore('View more');
        setBack('back');
        setAll('Category');
        setHallLabel('Hall');
        setCloseText('Close');
    }
  }, [intl.locale]);
  (0, _react.useEffect)(function () {
    var uniqueCategories = new Set(); // Créer un ensemble temporaire pour stocker les catégories uniques
    var _iterator = _createForOfIteratorHelper(cell.expos),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var expo = _step.value;
        var _iterator2 = _createForOfIteratorHelper(expo.categories),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var cat = _step2.value;
            var categoryName = (0, _utils.i18nData)(cat, 'name', intl, defaultLanguage);
            uniqueCategories.add(categoryName); // Ajouter la catégorie à l'ensemble temporaire
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    setCategories(Array.from(uniqueCategories).sort()); // Mettre à jour categories avec les valeurs uniques de l'ensemble temporaire
  }, [cell.expos, intl.locale, defaultLanguage, catSelected]);
  var fetchData = function fetchData() {
    if (items.length < expos.length) {
      var maxIndexDatas = Math.min(indexDatas + 350, expos.length);
      var newDatas = expos.slice(indexDatas, maxIndexDatas);
      setTimeout(function () {
        setIndexDatas(function (prevIndexDatas) {
          return prevIndexDatas + newDatas.length;
        });
        setItems(function (prevItems) {
          var updatedItems = _toConsumableArray(prevItems);
          newDatas.forEach(function (expo) {
            if (!updatedItems.some(function (item) {
              return item.id === expo.id;
            })) {
              updatedItems.push(expo);
            }
          });
          return updatedItems;
        });
        if (maxIndexDatas >= expos.length) {
          setHasMore(false);
        } else {
          setHasMore(true);
        }
      }, 200);
    } else {
      setHasMore(false);
    }
  };
  if (!uri) {
    return null;
  }
  if (window.innerWidth > window.innerHeight) {
    return /*#__PURE__*/_react.default.createElement(_PlanCellHozizontal.default, {
      cell: cell,
      page: page,
      uriTransformer: uriTransformer,
      intl: intl,
      defaultLanguage: defaultLanguage,
      project: project,
      logEvent: logEvent,
      setCatSelected: setCatSelected,
      expos: expos,
      currentCategory: catSelected,
      colorSelected: cell.btn_select_color,
      expoSelected: selected,
      setSelected: setSelected,
      uri: uri,
      fetchData: fetchData,
      hasMore: hasMore,
      search: search,
      items: items,
      viewMore: viewMore,
      setSearch: setSearch,
      verifyCatIsInside: verifyCatIsInside,
      selected: selected,
      font: font,
      setShowOptions: setShowOptions,
      showOptions: showOptions,
      setCategories: setCategories,
      categories: categories,
      all: all,
      setAll: setAll,
      setPlaceholder: setPlaceholder,
      placeholder: placeholder,
      hallLabel: hallLabel,
      back: back,
      setBack: setBack,
      catSelected: catSelected,
      closeText: closeText
    });
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    style: {
      height: '100%',
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      fontFamily: font
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      height: '34%',
      width: '100%',
      position: 'fixed',
      top: '0%',
      background: 'rgb(235, 235, 235)'
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      width: '100%',
      height: '100%',
      position: 'relative'
    }
  }, /*#__PURE__*/_react.default.createElement(_reactThreeFiber.Canvas, {
    gl: {
      antialias: true
    },
    style: {
      height: '100%',
      width: '100%'
    }
  }, /*#__PURE__*/_react.default.createElement(_react.Suspense, {
    fallback: null
  }, /*#__PURE__*/_react.default.createElement(_GLTFView.default, {
    setCatSelected: setCatSelected,
    expos: expos,
    currentCategory: catSelected,
    intl: intl,
    logEvent: logEvent,
    page: page,
    uriTransformer: uriTransformer,
    uri: uri,
    expoSelected: selected,
    colorSelected: cell.btn_select_color,
    cell: cell,
    setSelected: setSelected,
    selectionSourceRef: selectionSourceRef,
    onLoad: function onLoad() {
      return setPlanLoaded(true);
    }
  }))), !planLoaded && /*#__PURE__*/_react.default.createElement("div", {
    style: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      width: '180px',
      height: '180px',
      borderRadius: '50%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      transform: 'translate(-50%, -50%)',
      /* centre correctement */
      zIndex: 10,
      pointerEvents: 'none'
    }
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: loader_uri_transformed,
    alt: "Loading...",
    style: {
      width: '100%',
      height: '100%'
    }
  })))), selected.length == 0 ? /*#__PURE__*/_react.default.createElement("div", {
    style: {
      top: '33%',
      height: '8%',
      width: '100%',
      position: 'fixed',
      zIndex: 20,
      background: cell.background_color
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateColumns: '50% 50%',
      background: cell.background_color,
      width: '90%',
      margin: 'auto',
      padding: '1.2em'
    }
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      padding: '0.4em'
    }
  }, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    onClick: function onClick() {
      return setShowOptions(true);
    },
    style: {
      padding: '0.8em',
      fontFamily: font,
      fontSize: '1.2em',
      border: '1px solid #ccc',
      borderRadius: '0.6em',
      background: 'white',
      color: 'black',
      display: 'grid',
      gridTemplateColumns: '7fr 1fr'
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      color: 'black'
    }
  }, catSelected.length >= 16 ? catSelected.slice(0, 16) + '...' : catSelected || all), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("svg", {
    fill: "#000000",
    width: '1em',
    height: '1em',
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/_react.default.createElement("g", {
    "data-name": "arrow-ios-downward"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    width: "24",
    height: "24",
    opacity: "0"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M12 16a1 1 0 0 1-.64-.23l-6-5a1 1 0 1 1 1.28-1.54L12 13.71l5.36-4.32a1 1 0 0 1 1.41.15 1 1 0 0 1-.14 1.46l-6 4.83A1 1 0 0 1 12 16z"
  })))))), showOptions && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    onClick: function onClick() {
      setShowOptions(false);
    },
    style: {
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 100,
      overflow: 'visible'
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      position: 'fixed',
      backgroundColor: cell.background_color,
      borderRadius: '0.6em',
      padding: '1em',
      width: '80vw',
      left: '10%',
      top: '0vh',
      height: '64vh',
      marginTop: '10vh',
      overflow: 'auto',
      zIndex: 105,
      scrollbarWidth: '1em',
      scrollbarColor: cell.text_form_color,
      boxShadow: '12px 12px 12px rgba(0,0,0,0.4)',
      WebkitOverflowScrolling: 'touch'
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    onClick: function onClick() {
      logEvent('click', {
        cellId: cell.id,
        pageId: page.id,
        languageCode: intl.locale,
        categoryName: 'all'
      });
      setCatSelected('');
      setSelected([]);
      setShowOptions(false);
    },
    style: {
      padding: '0.8em',
      cursor: 'pointer',
      color: cell.text_form_color,
      borderBottom: '1px solid ' + cell.text_form_color,
      fontWeight: 'bold'
    }
  }, all), categories.map(function (category) {
    return /*#__PURE__*/_react.default.createElement("div", {
      key: category,
      onClick: function onClick() {
        logEvent('click', {
          cellId: cell.id,
          pageId: page.id,
          languageCode: intl.locale,
          categoryName: category
        });
        setCatSelected(category);
        setSelected([]);
        setShowOptions(false);
      },
      style: {
        padding: '0.8em',
        cursor: 'pointer',
        color: cell.text_form_color,
        borderBottom: '1px solid ' + cell.text_form_color
      }
    }, category);
  }), /*#__PURE__*/_react.default.createElement("button", {
    onClick: function onClick() {
      return setShowOptions(false);
    },
    style: {
      top: '80vh',
      padding: '0.8em',
      width: '80vw',
      fontSize: '1em',
      borderRadius: '0.6em',
      position: 'fixed',
      color: cell.text_form_color,
      backgroundColor: cell.background_color,
      border: 'none',
      outline: 'none',
      boxShadow: '12px 12px 12px rgba(0,0,0,0.4)'
    }
  }, "Close")))))), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      padding: '0.4em'
    }
  }, /*#__PURE__*/_react.default.createElement("input", {
    type: "search",
    placeholder: placeholder,
    value: search,
    onChange: function onChange(e) {
      setSearch(e.target.value);
    },
    style: {
      fontFamily: font,
      top: 0,
      width: '100%',
      borderRadius: '0.6em',
      fontSize: '1.2em',
      padding: '0.8em',
      margin: 'auto',
      textAlign: 'start',
      color: 'black'
    }
  }))))) : '', /*#__PURE__*/_react.default.createElement("div", {
    style: {
      color: cell.text_form_color,
      overflow: 'scroll',
      position: 'fixed',
      zIndex: 1,
      top: '42%',
      height: '61%',
      width: '100%',
      display: 'flex',
      alignContent: 'flex-start',
      justifyContent: 'flex-start',
      flexDirection: 'column',
      backgroundColor: cell.background_color,
      fontFamily: font
    }
  }, selected.length == 0 ? /*#__PURE__*/_react.default.createElement(_reactInfiniteScroller.default, {
    pageStart: 0,
    loadMore: fetchData,
    hasMore: hasMore,
    useWindow: false,
    loader: /*#__PURE__*/_react.default.createElement("h2", {
      key: 0,
      style: {
        textAlign: 'center'
      }
    }, "Loading...")
  }, items.map(function (expo, index) {
    var expoName = (0, _utils.i18nData)(expo, 'expo_name', intl, defaultLanguage) ? (0, _utils.i18nData)(expo, 'expo_name', intl, defaultLanguage) : expo.expo_name;
    if ((expoName.toLowerCase().includes(search.toLowerCase()) || expo.expo_number.toLowerCase().includes(search.toLowerCase())) && verifyCatIsInside(intl, defaultLanguage, expo.categories, catSelected)) {
      return /*#__PURE__*/_react.default.createElement(_react.Fragment, {
        key: expo.id + '_' + index
      }, /*#__PURE__*/_react.default.createElement("div", {
        onClick: function onClick() {
          selectionSourceRef.current = 'list';
          setSelected([expo]);
          logEvent('click', {
            cellId: cell.id,
            pageId: page.id,
            languageCode: intl.locale,
            expoName: expo.expo_name,
            expoNumber: expo.expo_number
          });
        },
        style: {
          marginTop: '0.2em',
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',
          color: cell.text_form_color,
          textAlign: 'center',
          height: '2.8em',
          padding: '0.2em',
          cursor: 'pointer',
          margin: 'auto',
          width: '86%'
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        style: {
          textAlign: 'start',
          marginTop: '2.2em',
          color: cell.text_form_color,
          fontSize: '1em'
        }
      }, (0, _utils.i18nData)(expo, 'expo_name', intl, defaultLanguage)), /*#__PURE__*/_react.default.createElement("div", {
        style: {
          display: 'flex',
          padding: '1em'
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        style: {
          textAlign: 'center',
          width: '50%',
          fontSize: '0.8em'
        }
      }, /*#__PURE__*/_react.default.createElement("button", {
        style: {
          fontFamily: font,
          fontSize: '1em',
          width: '100%',
          height: '100%',
          background: cell.background_btn_left,
          color: cell.color_text_left,
          padding: '1em',
          border: 'none',
          outline: 'none'
        }
      }, expo.expo_number)), /*#__PURE__*/_react.default.createElement("div", {
        style: {
          textAlign: 'center',
          width: '50%'
        }
      }, /*#__PURE__*/_react.default.createElement("button", {
        style: {
          fontFamily: font,
          fontSize: '1em',
          height: '100%',
          background: cell.background_btn_right,
          padding: '1em',
          width: '100%',
          color: cell.color_text_right,
          outline: 'none',
          border: 'none'
        }
      }, viewMore)))), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("hr", {
        style: {
          color: cell.border_form_color,
          width: '86%',
          margin: 'auto',
          marginTop: '1.8em'
        }
      }));
    } else {
      return null;
    }
  })) : /*#__PURE__*/_react.default.createElement("div", {
    style: _defineProperty(_defineProperty(_defineProperty({
      fontFamily: font,
      left: 0,
      width: '100%',
      zIndex: 20,
      overflow: 'scroll',
      height: '70%',
      top: '33%',
      position: 'fixed'
    }, "zIndex", 2), "backgroundColor", cell.background_color), "textAlign", 'center')
  }, /*#__PURE__*/_react.default.createElement("button", {
    style: {
      background: 'rgba(0,0,0,0)',
      border: 'none',
      outline: 'none',
      color: cell.text_form_color,
      height: '3em',
      width: '3em',
      fontSize: '1.4em',
      position: 'fixed',
      marginTop: '1em',
      left: '1em'
    },
    onClick: function onClick() {
      setSelected([]);
    }
  }, /*#__PURE__*/_react.default.createElement("svg", {
    width: "100%",
    height: "auto",
    viewBox: "0 0 106 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    x: "104.5",
    y: "104.5",
    width: "103",
    height: "103",
    rx: "50",
    transform: "rotate(-180 104.5 104.5)",
    fill: "none",
    stroke: cell.text_form_color,
    "stroke-width": "3"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M41.3359 50.9023L50.7109 41.5273C51.4141 40.7656 52.6445 40.7656 53.3477 41.5273C54.1094 42.2305 54.1094 43.4609 53.3477 44.1641L47.1953 50.375L65.125 50.375C66.1797 50.375 67 51.1953 67 52.25C67 53.2461 66.1797 54.125 65.125 54.125L47.1953 54.125L53.3477 60.2773C54.1094 60.9805 54.1094 62.2109 53.3477 62.9141C52.6445 63.6758 51.4141 63.6758 50.7109 62.9141L41.3359 53.5391C40.5742 52.8359 40.5742 51.6055 41.3359 50.9023Z",
    fill: cell.text_form_color
  }))), selected.map(function (expo) {
    return /*#__PURE__*/_react.default.createElement(_react.Fragment, {
      key: expo.id
    }, /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("p", {
      style: {
        fontSize: '1.2em',
        marginLeft: '25%',
        textAlign: 'start',
        marginTop: '0.3em'
      }
    }, expo.categories.length ? expo.categories.map(function (category, index) {
      return /*#__PURE__*/_react.default.createElement(_react.Fragment, {
        key: index
      }, (0, _utils.i18nData)(category, 'name', intl, defaultLanguage), expo.categories.length > index + 1 ? ' | ' : '');
    }) : ''), /*#__PURE__*/_react.default.createElement("h1", {
      style: _defineProperty({
        marginTop: '0.4em',
        fontSize: '2em',
        fontWeight: 'bold',
        textAlign: 'center',
        marginLeft: '25%'
      }, "textAlign", 'start')
    }, (0, _utils.i18nData)(expo, 'expo_name', intl, defaultLanguage)), /*#__PURE__*/_react.default.createElement("div", {
      style: {
        marginTop: '1em',
        width: '30%',
        marginLeft: '25%',
        display: 'grid',
        gridTemplateColumns: '50% 50%'
      }
    }, expo.expo_hall ? /*#__PURE__*/_react.default.createElement("div", {
      style: {
        textAlign: 'center',
        padding: '0.8em',
        background: cell.background_btn_left,
        color: cell.color_text_left
      }
    }, hallLabel, " ", expo.expo_hall) : '', /*#__PURE__*/_react.default.createElement("div", {
      style: {
        textAlign: 'center',
        padding: '0.8em',
        background: cell.background_btn_right,
        color: cell.color_text_right
      }
    }, expo.expo_number)), /*#__PURE__*/_react.default.createElement("div", {
      style: expo.logo_uri.length ? {
        marginTop: '1.6em',
        display: 'grid',
        gridTemplateColumns: '40% 60%',
        padding: '3.2em'
      } : {
        marginTop: '2em',
        display: 'grid',
        gridTemplateColumns: '0% 100%',
        padding: '3.2em'
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        padding: '0.4em'
      }
    }, expo.logo_uri.length ? /*#__PURE__*/_react.default.createElement("img", {
      src: uriTransformer(expo.logo_uri),
      width: '100%',
      height: 'auto',
      style: {
        margin: 'auto',
        textAlign: 'center'
      }
    }) : ''), /*#__PURE__*/_react.default.createElement("div", {
      style: {
        padding: '0.4em'
      }
    }, /*#__PURE__*/_react.default.createElement("p", {
      style: {
        textAlign: 'start'
      }
    }, (0, _utils.i18nData)(expo, 'description', intl, defaultLanguage)))), /*#__PURE__*/_react.default.createElement("div", {
      style: {
        marginTop: '2em',
        textAlign: 'center',
        width: '100%',
        padding: '3.em'
      }
    }, expo.website_uri.length ? 'Website : ' + expo.website_uri : ''));
  }))));
};
var PlanCellWrapper = function PlanCellWrapper(props) {
  return /*#__PURE__*/_react.default.createElement(_react.Suspense, {
    fallback: null
  }, /*#__PURE__*/_react.default.createElement(PlanCell, props));
};
var verifyCatIsInside = function verifyCatIsInside(intl, defaultLanguage, categoriesExpo, categorySelected) {
  if (!categorySelected || !categorySelected.length || categorySelected.replace(' ', '') == '') {
    return true;
  }
  var _iterator3 = _createForOfIteratorHelper(categoriesExpo),
    _step3;
  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var expoCategory = _step3.value;
      if ((0, _utils.i18nData)(expoCategory, 'name', intl, defaultLanguage) == categorySelected) {
        return true;
      }
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }
  return false;
};
exports.verifyCatIsInside = verifyCatIsInside;
var _default = exports.default = (0, _reactIntl.injectIntl)(PlanCellWrapper);